
interface NavigationProps {
  slides: Array<{ id: number; title: string; type: string }>;
  currentSlide: number;
  onNext: () => void;
  onPrev: () => void;
  onGoTo: (index: number) => void;
}

export default function Navigation({ slides, currentSlide, onNext, onPrev, onGoTo }: NavigationProps) {
  return (
    <div className="mt-12 space-y-6">
      {/* 主导航按钮 */}
      <div className="flex items-center justify-center space-x-4">
        <button
          onClick={onPrev}
          disabled={currentSlide === 0}
          className="flex items-center space-x-2 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          <span>上一页</span>
        </button>
        
        <div className="flex items-center space-x-3 bg-white rounded-lg px-6 py-3 shadow-md">
          <i className="ri-slideshow-line text-blue-600"></i>
          <span className="text-gray-700 font-medium">
            {currentSlide + 1} / {slides.length}
          </span>
        </div>
        
        <button
          onClick={onNext}
          disabled={currentSlide === slides.length - 1}
          className="flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer"
        >
          <span>下一页</span>
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
      
      {/* 幻灯片缩略图导航 */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">快速导航</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7 gap-3">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              onClick={() => onGoTo(index)}
              className={`p-3 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                currentSlide === index
                  ? 'bg-blue-600 text-white shadow-md transform scale-105'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <div className="flex flex-col items-center space-y-1">
                <span className="text-xs opacity-75">{index + 1}</span>
                <span className="text-xs leading-tight text-center">{slide.title}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
      
      {/* 进度条 */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-gray-600">演示进度</span>
          <span className="text-sm font-semibold text-blue-600">
            {Math.round(((currentSlide + 1) / slides.length) * 100)}%
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
          ></div>
        </div>
      </div>
      
      {/* 快捷操作 */}
      <div className="flex items-center justify-center space-x-4">
        <button
          onClick={() => onGoTo(0)}
          className="flex items-center space-x-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          <span>回到首页</span>
        </button>
        
        <button
          onClick={() => onGoTo(slides.length - 1)}
          className="flex items-center space-x-2 px-4 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-flag-line"></i>
          <span>跳到总结</span>
        </button>
        
        <button className="flex items-center space-x-2 px-4 py-2 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-printer-line"></i>
          <span>打印资料</span>
        </button>
      </div>
    </div>
  );
}
